// extracted by mini-css-extract-plugin
export var container = "_ka-0";
export var dotAnimation = "_ka-2";
export var dotsLoading = "_ka-1";